import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // Enables the i18next backend
  .use(Backend)
  // Enable automatic language detection
  // OF: Decide if we need this?
  //   .use(LanguageDetector)
  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    lng: "en",
    backend: {
      // Bust browser/CDN caches of the locale JSON on every deploy.
      queryStringParams: { v: process.env.GATSBY_BUILD_ID || "dev" },
      fallbackLng: "en",
      debug: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    },
  });

export default i18n;
